import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectIsCommercial } from '../../../../selectors/offer';
import { selectHighDemandCoefficient } from '../../../../selectors/publishTerms';
import { DiscountBanner } from '../../components/DiscountBanner';
import { HighDemandBanner } from '../../components/HighDemandBanner';
import * as styles from './HighDemandBannerContainer.css';

export const HighDemandBannerContainer = (): JSX.Element | null => {
  const highDemandCoefficient = useSelector(selectHighDemandCoefficient);
  const isCommercial = useSelector(selectIsCommercial);

  if (!highDemandCoefficient || highDemandCoefficient === 1 || !isCommercial) {
    return null;
  }

  if (highDemandCoefficient > 1) {
    return (
      <div className={styles['banner-wrapper']}>
        <HighDemandBanner />
      </div>
    );
  }

  return (
    <div className={styles['banner-wrapper']}>
      <DiscountBanner />
    </div>
  );
};
